<template>
    <div>
        <v-btn
                flat
                @click.stop="dialog = true"
        >
            <v-icon left>edit</v-icon>Edit
        </v-btn>

        <v-dialog
                v-model="dialog"
                max-width="500"
        >
            <v-card>
                <v-card-title class="headline">Edit supplier</v-card-title>
                <v-card-text>
                    <v-layout row wrap>
                        <v-flex xs12 sm12 md12>
                            <v-text-field
                                    v-validate="'required'"
                                    v-model="data.name"
                                    :error-messages="errors.collect('data.name')"
                                    label="Name"
                                    data-vv-name="data.name"
                                    browser-autocomplete="off"
                            ></v-text-field>
                        </v-flex>

                        <v-flex xs12 sm12 md12>
                            <v-text-field
                                    v-validate="'required|email'"
                                    v-model="data.email"
                                    :error-messages="errors.collect('data.email')"
                                    label="E-mail"
                                    data-vv-name="data.email"
                            ></v-text-field>
                        </v-flex>

                        <v-flex xs12 sm12 md12 v-if="email_usado">
                            <v-alert
                                    :value="true"
                                    color="error"
                                    icon="warning"
                                    outline
                            >
                                This email is already in use.
                            </v-alert>
                        </v-flex>

                        <v-flex xs12 sm12 md12>
                            <v-btn block outline color="red" v-if="message_error">{{ message_error}}</v-btn>
                        </v-flex>
                    </v-layout>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn
                            color="green darken-1"
                            flat="flat"
                            @click="dialog = false"
                    >
                        Cancel
                    </v-btn>

                    <v-btn
                            color="green darken-1"
                            flat="flat"
                            @click="update"
                    >
                        Edit
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    export default {
        props: ['ftn'],
        data () {
            return {
                data: {},
                dialog: false,
                error : false,
                message_error : null,
                cliente: null,
                email_usado: false
            }
        },
        created: function() {
            this.data = this.ftn;
        },
        methods: {
            update : function() {
                this.$validator.validateAll().then((result) => {
                    if(result){
                        this.$store.dispatch('updateAmc', this.data).then((res) => {
                            this.$emit('update');
                            this.dialog = false;
                        }).catch((error) => {
                        });
                    }
                });
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/admin/amcs/components/EditFtnModal.vue